<template>
	<CloToolbar reverse color="primaryDark">
		<CloToolbarGroup>
			<CloToolbarItem :label="$t('tripReport.myTripReports')" :href="baseUrl + 'mytripreports'" previous />
		</CloToolbarGroup>
		<CloToolbarGroup align="right">
			<CloToolbarItem
				v-if="prevHref"
				:href="prevHref"
				:label="$t('generic.Previous')"
				previous
				:divider="prevHref !== '' && nextHref !== ''"
			/>
			<CloToolbarItem v-if="nextHref" :href="nextHref" :label="$t('generic.Next')" next />
		</CloToolbarGroup>
	</CloToolbar>
</template>

<script>
import Vue from 'vue';
import CloToolbar from '@/navigation/CloToolbar/CloToolbar.vue';
import CloToolbarGroup from '@/navigation/CloToolbar/CloToolbarGroup.vue';
import CloToolbarItem from '@/navigation/CloToolbar/CloToolbarItem.vue';
export default {
	name: 'ReportToolbar',
	components: {
		CloToolbar,
		CloToolbarGroup,
		CloToolbarItem,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
			prevTripId: window.tripReport.prev,
			nextTripId: window.tripReport.next,
		};
	},
	computed: {
		nextHref() {
			let href = '';
			if (this.nextTripId != null) {
				href = `${this.baseUrl}tripreport/${this.nextTripId}`;
			}
			return href;
		},
		prevHref() {
			let href = '';
			if (this.prevTripId != null) {
				href = `${this.baseUrl}tripreport/${this.prevTripId}`;
			}
			return href;
		},
	},
};
</script>

<style lang="scss"></style>
